// extracted by mini-css-extract-plugin
export default {"button":"SaveButton_button__1NHdz","text":"SaveButton_text__EFo1N","icon":"SaveButton_icon__qeVit"};